import { IProviderRoutes } from "~/interfaces/provider";
import User from "~/models/user";
import { Constructor } from "../../global/constructor";
import Provider from "./new/provider";


export default class AccountRelationUserProvider<T extends User = User> extends Provider<T> {
  routes: IProviderRoutes;

  constructor(
    protected modelType: Constructor<T>,
    public modelRoot: string,
    public collectionRoot: string
  ) {
    super(modelType, modelRoot, collectionRoot);
  }

}